export default __webpack_public_path__ + "static/media/banner-thumb.67ab8e7e.png";